import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpParams } from '@capacitor/core';
import { ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';

interface IBoletosParams extends HttpParams {
  empresa: string;
  contrato: string;
  dtVencimento?: string;
}

export interface IArquivoLeitura {
  idArquivo?: string;
  idLogin?: string;
  loginUsuario?: string;
  nomeUsuario?: string;
  idEmpresa?: string;
  numContrato?: string;
}

interface EnviarAvisoDTO {
  lojas: Array<{NumContrato: string}>;
  title: string;
  texto: string;
  sendEmail: boolean;
}

@Injectable()
export class BoletosCobrancaProvider {
  private header = APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {}

  async enviarAviso(
    empresa: string,
    data: EnviarAvisoDTO
  ): Promise<{ Item: any; erro: string }> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'boletoscobranca';

      me.http
        .post(url, data, {
          headers: me.header,
          params: {
            empresa: empresa,
            operacao: 'enviarAviso',
            tipoAviso: 'Aviso de Boletos e Cobrança'
          },
        })
        .subscribe(
          (result: any) => {
            ////console.log(result);
            //resolve(result.json());
            var jsonData = result;

            if (jsonData) {
              if (jsonData.status_ret != 'NOK') {
                var datasuccess = {
                  Item: jsonData,
                  erro: '',
                };

                me.itemret = datasuccess;
              } else {
                var errodatavazio = {
                  Item: null,
                  erro: 'Erro na consulta dos boletos e avisos.',
                };
                me.itemret = errodatavazio;
              }

              //resolve(me.itemret);
            } else {
              var errodatavazio1 = {
                Item: null,
                erro: 'Nenhum registro encontrado.',
              };
              me.itemret = errodatavazio1;
            }
            resolve(me.itemret);
          },
          (error) => {
            var msg = '';
            if (error.status == 401) {
              msg = error.statusText;
            } else {
              msg = error.error;
            }
            let errojson = msg;

            var errochamada = {
              Item: null,
              erro: errojson,
            };
            me.itemret = errochamada;
            reject(me.itemret);
          }
        );
    });
  }

  get(params: any): Promise<{ Item: any; erro: string }> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'boletoscobranca';

      me.http.get(url, { headers: me.header, params }).subscribe(
        (result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData = result;

          if (jsonData.length != 0) {
            if (jsonData[0].status_ret != 'NOK') {
              var datasuccess = {
                Item: jsonData,
                erro: '',
              };

              me.itemret = datasuccess;
            } else {
              var errodatavazio = {
                Item: null,
                erro: 'Erro na consulta dos boletos e avisos.',
              };
              me.itemret = errodatavazio;
            }

            //resolve(me.itemret);
          } else {
            var errodatavazio1 = {
              Item: null,
              erro: 'Nenhum registro encontrado.',
            };
            me.itemret = errodatavazio1;
          }
          resolve(me.itemret);
          console.log(me.itemret);
        },
        (error) => {
          var msg = '';
          if (error.status == 401) {
            msg = error.statusText;
          } else {
            msg = error.error;
          }
          let errojson = msg;

          var errochamada = {
            Item: null,
            erro: errojson,
          };
          me.itemret = errochamada;
          reject(me.itemret);
        }
      );
    });
  }

  getFilesByIds(ids: string[] | number[], isDownload = null): Promise<any> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url =
        APIService.API_URL +
        'boletoscobranca?operacao=arquivos&ids=' +
        ids.join(',');


      if(isDownload != null && typeof isDownload == "boolean")
      {
        url += '&isDownload=' + isDownload;
      }

      me.http.get(url, { headers: this.header }).subscribe(
        (result: ApiPaginateResult) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  async postLeituraArquivo(body: IArquivoLeitura): Promise<any> {
    var me = this;

    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'boletoscobranca?operacao=lido';

      me.http.post(url, body, { headers: this.header }).subscribe(
        (result: any) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
}
